// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4932":"css/admin-app.7057","9270":"css/app.7057"}[chunkId] + ".css";
};